module.exports = __webpack_public_path__ + "static/media/stars-375.52c3b451.webp";